<template>
  <div class="profile-photo">
    <b-link
      :to="{
        name: `influencer.profile-page`,
        params: {
          id: user.influencer_uid,
          username: user.username,
        },
      }"
    >
      <UserAvatar :photo-url="user.profile_photo_url" />
    </b-link>
  </div>
</template>

<script>
import UserAvatar from '@/views/components/User/UserAvatar'
export default {
  components: { UserAvatar },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped></style>
